export const eagleStatusEnum = {
  SENDING: 'SENDING',
  WAITING: 'WAITING',
  ERROR: 'ERROR',
  FINISHED: 'FINISHED',
}